import { IResearchArea } from '@/shared/types';

export const modifyBodySystemsData = (items: Array<IResearchArea>): Array<IResearchArea> => {
  return items.map((item: IResearchArea) => {
    return { ...item, active: true };
  });
};
